import styled from '@emotion/styled'
export const PieChart = styled.div`
border-bottom: 1px dashed #ddd;
margin-bottom: 20px;
`

export const SubmitButton = styled.div`
display:flex;
flex-direction:row-reverse;
padding-top: 20px;
`

export const Calories = styled.div`
display: flex;
justify-content: center;
font-size: 23px;
font-family: ProximaNova;
padding-bottom: 16px;
`